import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import CloseIcon from 'styles/images/svg/close.svg';
import { useNavigate } from "react-router-dom";


const ShortHeaderWithCloseBtn = (props) => {

	const navigate = useNavigate();

    return (

    	<div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsCenter, sharedStyles['py-[24px]']].join(' ')}>
	        <div className={[shortHeaderStyles['header-logo-back'], sharedStyles['w-full']].join(' ')}>
	            <img onClick={() => navigate('/', { replace: true })} className={shortHeaderStyles['back-btn']} src={CloseIcon} width={18} height={18}  />
	            <img src={Logo} alt="Dr20" className={shortHeaderStyles.logo} />
	            <span className={shortHeaderStyles['hide-like-back-btn']} />
	        </div>
	        <span className={[sharedStyles['text-green'], sharedStyles['font-weight-900'], sharedStyles['mt-[8px]']].join(' ')}>HEALTH IS WEALTH</span>
        </div>

    );
}

export default ShortHeaderWithCloseBtn;
